import(/* webpackMode: "eager" */ "/home/ubuntu/download/69bedf577d947e0014158c39/panoramatowers/src/app/services/[serviceSlug]/page.tsx");
